import styled from 'styled-components';

export default styled.div`
  border: 1px solid rgba(72, 94, 144, 0.16);
  border-top: none;
  width: ${props => props.width || 240}px;
  ${props => (props.cRight ? 'right: ' : '')} ${props =>
  props.cRight ? props.cRight : ''}${props => (props.cRight ? 'px;' : '')}
  padding: ${props => (props.cRight ? '25px' : '25px 10px')};
  position: absolute;
  top: 80px;
  background: #fff;
  z-index: 1000;

  &::after,
  &::before {
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &::after {
    top: -16px;
    ${props => (props.left ? 'left: ' : '')} ${props => (props.left ? props.left : '')}${props =>
  props.left ? 'px;' : ''}
    ${props => (props.right ? 'right: ' : '')} ${props =>
  props.right ? props.right : ''}${props => (props.right ? 'px;' : '')}
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #fff;
    border-width: 8px;
    margin-left: -8px;
  }

  &::before {
    top: -20px;
    ${props => (props.left ? 'left: ' : '')} ${props =>
  props.left ? props.left - 2 : ''}${props => (props.left ? 'px;' : '')}
    ${props => (props.right ? 'right: ' : '')} ${props =>
  props.right ? props.right - 2 : ''}${props => (props.right ? 'px;' : '')}
    border-color: rgba(0, 0, 0, 0);
    border-bottom-color: rgba(72, 94, 144, 0.16);
    border-width: 10px;
    margin-left: -8px;
  }

  .ant-menu-inline {
    border-right: none;
  }

  .ant-menu-item-group-title {
    font-size: 10px;
    font-weight: 700;
    font-family: -apple-system, BlinkMacSystemFont, 'Inter UI', Roboto, sans-serif;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #001737;
    margin-bottom: 5px;
    display: block;
    transition: all 0.25s;
    padding: 0;
  }
  .ant-menu-item {
    font-size: 13px;
    padding-left: 0 !important;
    white-space: nowrap;
  }

  .ant-menu-item-active:hover {
    background-color: transparent;
  }

  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: transparent;
  }

  .ant-menu-inline .ant-menu-item:not(:last-child) {
    margin-bottom: 0px;
  }
  .ant-menu-item-group-list .ant-menu-item {
    padding: 0;
  }

  .ant-menu-inline .ant-menu-item {
    margin-top: 0;
    display: list-item;
    height: 30px;
    line-height: 1.6;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .ant-menu-inline .ant-menu-item::after {
    border-right: none;
  }

  .ant-menu-item-selected {
    font-weight: 500;
  }
`;
